<style lang="scss" scoped></style>
<template>
    <div class="fullpage bg_fff">
        <!--StartFragment-->
        <div class="Section0" style="layout-grid:15.6000pt;">
            <pj-table></pj-table>
        </div>
        <!--EndFragment-->
    </div>
</template>
<script>
  import PjTable from "../components/pj-table";

  export default {
    name: "form-pj",
    components: {PjTable}
  };
</script>
